module.exports = __webpack_public_path__ + "static/media/default-error.f8c411a9.svg";